import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pghNumberMask'
})
export class NumberMaskPipe implements PipeTransform {
  readonly SEPARATORS = '. -_(),/';

  readonly COMMON_PATTERNS = {
    phone: '(###) ###-####'
  };

  transform(value: string, pattern: string) {
    pattern = this.COMMON_PATTERNS[pattern] || pattern;
    if (!value) {
      return '';
    } else if (!pattern) {
      return value;
    }

    const res = [];
    const length = (pattern.match(/#/g) || []).length;
    const valueArray = ('' + value).split('');

    if (value?.length > length) {
      return value;
    }
    pattern.split('').forEach(v => {
      if (v === '#') {
        res.push(valueArray.splice(0, 1));
      } else {
        if (valueArray.length) {
          res.push(v);
        }
      }
    });

    return res.join('');
  }

  parse(value: string, pattern: string) {
    pattern = this.COMMON_PATTERNS[pattern] || pattern;

    if (!value || !pattern) return '';
    const regex = new RegExp(this.buildRegex(pattern));
    const parsed = value.match(regex);

    if (!parsed) return value;
    return parsed.slice(1).join('');
  }

  buildRegex(pattern: string) {
    const res = ['^'];
    let counter = 0;

    pattern.split('').forEach(value => {
      if (value === '#') {
        counter++;
      } else if (this.SEPARATORS.indexOf(value) > -1) {
        if (counter) {
          res.push(`(\\d{${counter}})`);
        }

        res.push(`\\${value}`);
        counter = 0;
      }
    });

    if (counter) {
      res.push(`(\\d{${counter}})`);
    }

    return res.join('');
  }
}
